export const ENV = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "https://api.app.linqer.com.br",
  FIREBASE_API_KEY:
    process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDWOtuaMKt_0CEy19AsLYlzhdLhzuD-6-s",
  FIREBASE_AUTH_DOMAIN:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "datatrak-66f02.firebaseapp.com",
  FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID || "datatrak-66f02",
  FIREBASE_STORAGE_BUCKET:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "datatrak-66f02.appspot.com",
  FIREBASE_MESSAGING_SENDER_ID:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "941566991579",
  FIREBASE_APP_ID:
    process.env.REACT_APP_FIREBASE_APP_ID || "1:941566991579:web:14a7466bb592ee7f5940fe",
};

export function validateEnv() {
  const requiredKeys = [
    "API_BASE_URL",
    "FIREBASE_API_KEY",
    "FIREBASE_AUTH_DOMAIN",
    "FIREBASE_PROJECT_ID",
    "FIREBASE_STORAGE_BUCKET",
    "FIREBASE_MESSAGING_SENDER_ID",
    "FIREBASE_APP_ID",
  ];

  const missing = requiredKeys.filter((key) => !ENV[key]);
  return {
    isValid: missing.length === 0,
    missing,
  };
}
